define('home/models/activities/AddModActivity',[
    'home/models/Activity',
    'home/activityExpander',
], function (
    Activity,
    activityExpander
) {
    'use strict';

    /**
     * User added (the current) user as a moderator to a forum
     *
     * Relations {
     *     actor: {
     *         type: 'user',
     *         description: 'The user that did the adding'
     *     },
     *     object: {
     *         type: 'forum',
     *         description: The forum to which the user was added as a moderator
     *     }
     * }
     */
    return Activity.extend({
        defaults: {
            verb: 'add-mod',
        },

        initialize: function (attributes) {
            this.actor = attributes.actor;
            this.target = attributes.target;
        },

        parseRelatedModels: function (attributes, objects) {
            attributes.actor = activityExpander.buildUser(objects, attributes.actor);
            attributes.target = activityExpander.buildForum(objects, attributes.target);

            return attributes;
        },
    });
});

